import React, { useCallback } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';

import './why.lidya.points.less';

export const WhyLidya = function () {
  const { t } = useTranslation();
  const howToList = [
    {
      ImageComponent: useCallback(
        ({
          className, objectFit,
        }) => (
          <StaticImage
            src="../../../../images/getLoan/02.svg"
            alt={t('why.application.loan.description')}
            title={t('web.why.how.to.opportunity')}
            width={64}
            height={64}
            objectFit={objectFit}
            className={className}
          />
        ),
        [t],
      ),
      title: t('why.application.loan.title'),
      description: t('why.application.loan.description'),
    },
    {
      ImageComponent: useCallback(
        ({
          className, objectFit,
        }) => (
          <StaticImage
            src="../../../../images/getLoan/03.svg"
            alt={t('why.collaterals.loan.description')}
            title={t('why.collaterals.loan.title')}
            width={63}
            height={64}
            objectFit={objectFit}
            className={className}
          />
        ),
        [t],
      ),
      title: t('why.collaterals.loan.title'),
      description: t('why.collaterals.loan.description'),
    },
    {
      ImageComponent: useCallback(
        ({
          className, objectFit,
        }) => (
          <StaticImage
            src="../../../../images/getLoan/04.svg"
            alt={t('why.paperwork.loan.description')}
            title={t('why.paperwork.loan.title')}
            width={64}
            height={56}
            objectFit={objectFit}
            className={className}
          />
        ),
        [t],
      ),
      title: t('why.paperwork.loan.title'),
      description: t('why.paperwork.loan.description'),
    },
    {
      ImageComponent: useCallback(
        ({
          className, objectFit,
        }) => (
          <StaticImage
            src="../../../../images/getLoan/01.svg"
            alt={t('why.sameday.loan.description')}
            title={t('why.sameday.loan.title')}
            width={64}
            height={64}
            objectFit={objectFit}
            className={className}
          />
        ),
        [t],
      ),
      title: t('why.sameday.loan.title'),
      description: t('why.sameday.loan.description'),
    },
    {
      ImageComponent: useCallback(
        ({
          className, objectFit,
        }) => (
          <StaticImage
            src="../../../../images/getLoan/money.svg"
            alt={t('why.simple.loan.description')}
            title={t('why.simple.loan.title')}
            width={64}
            height={64}
            objectFit={objectFit}
            className={className}
          />
        ),
        [t],
      ),
      title: t('why.simple.loan.title'),
      description: t('why.simple.loan.description'),
    },
    {
      ImageComponent: useCallback(
        ({
          className, objectFit,
        }) => (
          <StaticImage
            src="../../../../images/getLoan/06.svg"
            alt={t('why.local.loan.description')}
            title={t('why.local.loan.title')}
            width={64}
            height={72}
            objectFit={objectFit}
            className={className}
          />
        ),
        [t],
      ),
      title: t('why.local.loan.title'),
      description: t('why.local.loan.description'),
    },
  ];

  return (
    <div className="o-whyLidya" id="why-lidya">
      <div className="m-globalContentContainer">
        <div className="m-whyHowTo__howContainer">
          {howToList.map((how) => (
            <div className="m-whyHowTo__individual" key={how.title}>
              <how.ImageComponent
                objectFit="contain"
                className="m-whyHowTo__svg"
              />
              <p className="a-whyHowTo__title">{how.title}</p>
              <p className="a-whyHowTo__subTitle">{how.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyLidya;
